import { createAction } from '../util';

export const setOutageData = createAction('SET_OUTAGE_DATA');
